// For conversational bots , chatwidget , assistant bots , one to one chat , group chat
export const scriptSrc = '/scripts/chatwidget/static/js/main.40c38bc1.js';
export const chatinwindowscriptSrc = '/scripts/chatInWindow/static/js/main.40c38bc1.js'; //For chat in window (in modal)
export const spinnetScriptSrc = '/scripts/spinnet/static/js/main.bb53f52e.js'; //For spinnet


export const fullBotScriptReset = async (hasSentParamsRef, isChatInWindow, removeBotStyle) => {
    try {
        if (typeof window.destroyChatWidget === "function") {
            window.destroyChatWidget();
        }
    } catch (err) {
        console.warn("Error while calling destroyChatBot script:", err);
    }

    if (removeBotStyle) {
        removeBotStyles();
    };

    if (hasSentParamsRef && hasSentParamsRef.current) {
        hasSentParamsRef.current = false;
    }
    window.getParamsFromFrontmNewWebApp = null;
    const root = document.getElementById("chat-bot-project-root");
    if (root) root.innerHTML = "";
    return true;
};


export const removeBotScript = () => {
    const existingScript = document.querySelector(`script[src="${scriptSrc}"]`);
    if (existingScript && existingScript.parentNode) {
        existingScript.parentNode.removeChild(existingScript);
        // console.log("Bot script removed");
    } else {
        // console.log("No Bot script exist");
    }
};


export const removeChatInWindowScript = () => {
    const existingScript = document.querySelector(`script[src="${chatinwindowscriptSrc}"]`);
    if (existingScript && existingScript.parentNode) {
        existingScript.parentNode.removeChild(existingScript);
        // console.log("Bot script removed");
    } else {
        // console.log("No Bot script exist");
    }
};

export const removeBotStyles = () => {
    const styleIds = [
        "chatbot-as-widget-styles",
        "chatbot-project-styles-conversational-bot",
        "chatbot-project-styles-assistantBot",
        "chatbot-as-chatinwindow-styles"
    ];
    styleIds.forEach(id => {
        const el = document.getElementById(id);
        if (el && el.parentNode) {
            el.parentNode.removeChild(el);
            // console.log("Style removed:", id);
        }
    });
};

export const loadBotScriptStyles = (styleId, stylePath) => {
    const existingLink = document.getElementById(styleId);

    // Remove existing if present
    if (existingLink && existingLink.parentNode) {
        existingLink.parentNode.removeChild(existingLink);
    }

    // Create new stylesheet link
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = stylePath;
    link.id = styleId;

    document.head.appendChild(link);
};

export const loadSpinnetScriptStyles = (styleId, stylePath) => {
    const existingLink = document.getElementById(styleId);

    // Remove existing stylesheet if present
    if (existingLink && existingLink.parentNode) {
        existingLink.parentNode.removeChild(existingLink);
    }

    // Create new stylesheet link
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = stylePath;
    link.id = styleId;

    document.head.appendChild(link);
};

export const sendParamsToEmbeddedChatbot = (params, hasSentParamsRef, retryCount = 0) => {
    const maxRetries = 5;
    if (typeof window.getParamsFromFrontmNewWebApp === "function") {
        window.getParamsFromFrontmNewWebApp(params);
        if (hasSentParamsRef && hasSentParamsRef.current) {
            hasSentParamsRef.current = true;
        }

    } else if (retryCount < maxRetries) {
        console.warn(`Retrying (${retryCount + 1}/${maxRetries})...`);
        setTimeout(() => sendParamsToEmbeddedChatbot(params, hasSentParamsRef, retryCount + 1), 500);
    } else {
        console.error("Chatbot script did not initialize in time for chatwidget.");
    }
};

export const sendParamsToSpinnet = (params, hasSentParamsRef, retryCount = 0) => {
    
    const maxRetries = 5;
    
    if (typeof window.initialBoatDetail === "function") {
        
        window.initialBoatDetail(params);
        if (hasSentParamsRef && hasSentParamsRef.current) {
            hasSentParamsRef.current = true;
        }

    } else if (retryCount < maxRetries) {
        console.warn(`Retrying (${retryCount + 1}/${maxRetries})...`);
        setTimeout(() => sendParamsToSpinnet(params, hasSentParamsRef, retryCount + 1), 500);
    } else {
        console.error("spinnet script did not initialize in time.....");
    }
};